import {
  Searchbar,
  AssistedSaleSearchbar,
  ServicesSearchbar
} from '@leroy-merlin-br/backpack-header'
import { liteClient as search } from 'algoliasearch/lite'

import { AlgoliaConfigProps } from 'scripts/react-components/entry-key/routes/routes'
import { useAnalyticsTags } from 'scripts/react-components/entry-key/hooks/useAnalyticsTags'

import { useUserResources } from 'shared/hooks'
import { insightsConfig } from 'shared/contexts/AlgoliaInstantSearch/lib'

export type SearchbarByContextProps = {
  algolia: AlgoliaConfigProps
  isGrandeSaoPauloRegion: boolean
  isServicesSearchbarEnabled: boolean
}

export function SearchbarByContext(props: Readonly<SearchbarByContextProps>) {
  const { algolia, isGrandeSaoPauloRegion, isServicesSearchbarEnabled } = props

  const { userControls } = useUserResources()

  const analyticsTags = useAnalyticsTags()

  const { indexName, appId, apiKey, retailMediaIndexName, serviceIndexName } =
    algolia

  const searchClient = search(appId, apiKey)

  const shouldShowServices =
    isGrandeSaoPauloRegion && isServicesSearchbarEnabled

  if (userControls?.isAssistedSale) {
    return <AssistedSaleSearchbar />
  }

  const algoliaConfig = {
    insightsClient: insightsConfig.insightsClient,
    searchClient,
    indexName,
    retailMediaIndexName,
    queries: [{ params: { analyticsTags }, indexName }]
  }

  if (shouldShowServices) {
    return (
      <ServicesSearchbar
        maxWidth="6xl"
        algolia={{
          ...algoliaConfig,
          productServicesIndexName: serviceIndexName
        }}
      />
    )
  }

  return <Searchbar algolia={algoliaConfig} />
}
